import React from 'react';

const EmailIcon = ({ classes }) => (
  <svg className={classes} viewBox="0 0 512 512">
    <g>
      <g>
        <path d="M256,224c-19.744,0-32,15.328-32,40s12.256,40,32,40s32-15.328,32-40S275.744,224,256,224z" />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M256,0C114.624,0,0,114.624,0,256s114.624,256,256,256s256-114.624,256-256S397.376,0,256,0z M416,272
			c0,35.296-28.704,64-64,64c-19.328,0-36.48-8.8-48.224-22.4C292.416,327.616,275.872,336,256,336c-37.696,0-64-29.6-64-72
			c0-42.4,26.304-72,64-72c12.64,0,23.84,3.584,33.376,9.6c2.464-5.632,8.064-9.6,14.624-9.6c8.832,0,16,7.168,16,16v64
			c0,17.664,14.336,32,32,32s32-14.336,32-32v-9.312c0-68-47.648-125.408-110.88-133.568c-42.016-5.376-82.432,9.088-110.976,39.808
			c-28.512,30.752-39.968,72.448-31.328,114.4c9.76,47.424,47.936,86.528,94.944,97.216c30.144,6.848,60.224,3.456,86.944-9.824
			c7.968-3.872,17.504-0.704,21.472,7.232c3.904,7.936,0.672,17.536-7.232,21.472c-22.208,11.008-46.208,16.608-70.816,16.608
			c-12.384,0-24.928-1.408-37.472-4.288c-59.968-13.632-106.752-61.504-119.2-121.984c-10.72-52.192,3.584-104.16,39.232-142.592
			c35.712-38.432,86.176-56.448,138.528-49.824C356.352,107.584,416,178.656,416,262.688V272z"
        />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export default EmailIcon;
